const translations = {
  "en": {
    "Aura": "Points",
    "Congrats, you've received": "Congrats, you've received",
    "Edgen Subscribe": "Ed Subscribe",
    "Get started": "Get started",
    "Rewards": "Rewards",
    "Unknown": "Unknown"
  },
  "zh-tw": {
    "Aura": "Points",
    "Congrats, you've received": "恭喜，你已收到",
    "Edgen Subscribe": "Ed 訂閱",
    "Get started": "開始使用",
    "Rewards": "獎勵",
    "Unknown": "未知"
  }
};

export default translations;
